'use es6';

import Observable from 'react-codemirror/model/Observable';
import { JUMP_TO_LINE_REGEX } from 'react-codemirror/constant/Find';
import { pick } from '../util/miniUnderscore.js';
/**
 * @typedef {Observable} FindState
 * @property {CodeMirror.Pos}   posFrom
 * @property {CodeMirror.Pos}   posTo
 * @property {Object}           overlay
 * @property {Object}           annotate
 * @property {String}           query
 * @property {String}           queryText
 * @property {String}           replaceText
 * @property {String}           jumpToLineText
 * @property {FindReplaceMode}  mode
 * @property {Boolean}          isCaseSensitive
 * @property {Boolean}          isRegex
 * @property {UInt}             matchCount
 */

/**
 * @classdesc Class representing search state for a CodeMirror instance.
 * @class {FindState}
 * @extends {Observable}
 */

export default class FindState extends Observable {
  toJSON() {
    return pick(this, ['queryText', 'replaceText', 'jumpToLineText', 'isCaseSensitive', 'isRegex', 'mode']);
  }

}
FindState.DEFAULT_FIELDS = Object.freeze(['posFrom', 'posTo', 'overlay', 'annotate', {
  name: 'query',
  value: null
}, {
  name: 'queryText',
  value: ''
}, {
  name: 'replaceText',
  value: ''
}, {
  name: 'jumpToLineText',
  value: '',

  validator(val) {
    if (typeof val !== 'string') {
      return false;
    }

    if (val === '') {
      return true;
    }

    const match = val.match(JUMP_TO_LINE_REGEX);

    if (!match) {
      return false;
    }

    const [, line] = match;

    if (line >= 1) {
      return true;
    }

    return false;
  }

}, {
  name: 'mode',
  value: null
}, {
  name: 'isCaseSensitive',
  value: false
}, {
  name: 'isRegex',
  value: false
}, {
  name: 'matchCount',
  value: 0
}]);